import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FormFieldWrapper } from '../FormFieldWrapper';

export const FormDropDownList: React.FC<
  FieldRenderProps & { dataUsesTranslations?: boolean; isLoading?: boolean }
> = fieldRenderProps => {
  const { disabled, isLoading } = fieldRenderProps;
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    const handleScrollOutside = (event: Event) => {
      if (!isOpen) {
        return;
      }

      const dropdownElement = document.querySelector('.k-animation-container');
      if (dropdownElement && dropdownElement.contains(event.target as Node)) {
        return;
      }

      setIsOpen(false);
    };

    const controller = new AbortController();
    document.addEventListener('wheel', handleScrollOutside, { signal: controller.signal });
    document.addEventListener('scroll', handleScrollOutside, { signal: controller.signal, capture: true });

    return () => {
      controller.abort();
    };
  }, [isOpen, setIsOpen]);

  let valueForField = fieldRenderProps.value;
  if (fieldRenderProps.dataUsesTranslations && fieldRenderProps.dataItemKey && fieldRenderProps.value) {
    const key = fieldRenderProps.dataItemKey as string;
    valueForField = fieldRenderProps.data.find(
      (d: { [key: string]: unknown }) => d[key] === (fieldRenderProps.value as { [key: string]: unknown })[key]
    );
  }

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <DropDownList
        name={fieldRenderProps.name}
        id={fieldRenderProps.id}
        data={fieldRenderProps.data}
        textField={fieldRenderProps.textField}
        dataItemKey={fieldRenderProps.dataItemKey}
        value={valueForField}
        onChange={fieldRenderProps.onChange}
        onFocus={fieldRenderProps.onFocus}
        onBlur={fieldRenderProps.onBlur}
        valid={fieldRenderProps.valid}
        label={undefined}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        opened={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
